import { render, staticRenderFns } from "./CashPack.vue?vue&type=template&id=6b80ce9a&scoped=true"
import script from "./CashPack.vue?vue&type=script&lang=js"
export * from "./CashPack.vue?vue&type=script&lang=js"
import style0 from "./CashPack.vue?vue&type=style&index=0&id=6b80ce9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80ce9a",
  null
  
)

export default component.exports